export const SHOP_BY_LIST_CTA_TEXT = 'Match my list';
export const SHOP_BY_LIST_CTA_TOOLTIP_KEY = 'wtr_shop_by_list_tooltip';
